import script from "./InputPanel.vue?vue&type=script&setup=true&lang=ts"
export * from "./InputPanel.vue?vue&type=script&setup=true&lang=ts"

import "./InputPanel.vue?vue&type=style&index=0&id=5534ffc4&scoped=true&lang=css"

import exportComponent from "/home/centos/workspace/Blueshift Core/blueshift-frontend-PROD-deploy/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5534ffc4"]])

export default __exports__